import translations from '@/utils/v2/translations'

const FALLBACK_LANGUAGE = 'en'
const SLOT_REGEX = /{{(\d+)}}/g

/**
 * 是否可以填充 slot
 * @param value 原始字串
 * @returns 是否可以填充 slot
 */
const canFillSlots = (value: string) => {
  return SLOT_REGEX.test(value)
}

/**
 * 填充 slot 的值
 * @param value 原始字串
 * @param slots 要填充的值
 * @returns 填充後的字串
 *
 * @example
 * fillSlots("Hello, {{0}}!", ["World"]) => "Hello, World!"
 */
const fillSlots = (value: string, slots: Array<string>) => {
  return value.replace(SLOT_REGEX, (match, index) => slots[index] ?? match)
}

export default function useTranslation () {
  return {
    t: (
      language: string,
      key: string,
      slots?: Array<string>,
    ) => {
      const result =
        translations[language]?.[key] ?? translations[FALLBACK_LANGUAGE]?.[key]
      if (result && canFillSlots(result) && slots && slots.length > 0) {
        return fillSlots(result, slots)
      }
      return result ?? key
    },
  }
}
